import { useReducer } from "react";

// Action types
export const PLACEMENT_ACTIONS = {
  UPDATE_FIELD: "UPDATE_FIELD",
  UPDATE_CONTRACT_FIELD: "UPDATE_CONTRACT_FIELD",
  UPDATE_SECTION_FIELD: "UPDATE_SECTION_FIELD",
  UPDATE_SECTION_ARRAY_ITEM: "UPDATE_SECTION_ARRAY_ITEM",
  UPDATE_NESTED_ARRAY_ITEM: "UPDATE_NESTED_ARRAY_ITEM",
  ADD_SECTION_ARRAY_ITEM: "ADD_SECTION_ARRAY_ITEM",
  REMOVE_SECTION_ARRAY_ITEM: "REMOVE_SECTION_ARRAY_ITEM",
  SET_PLACEMENT: "SET_PLACEMENT",
};

// Reducer function
function placementReducer(state, action) {
  switch (action.type) {
    case PLACEMENT_ACTIONS.SET_PLACEMENT:
      return action.payload;

    case PLACEMENT_ACTIONS.UPDATE_FIELD:
      return {
        ...state,
        [action.field]: action.value,
      };

    case PLACEMENT_ACTIONS.UPDATE_CONTRACT_FIELD:
      return {
        ...state,
        contract: {
          ...state.contract,
          [action.field]: action.value,
        },
      };

    case PLACEMENT_ACTIONS.UPDATE_SECTION_FIELD: {
      const newSections = [...state.sections];
      newSections[action.sectionIndex] = {
        ...newSections[action.sectionIndex],
        [action.field]: action.value,
      };
      return {
        ...state,
        sections: newSections,
      };
    }

    case PLACEMENT_ACTIONS.UPDATE_SECTION_ARRAY_ITEM: {
      const newSections = [...state.sections];
      const section = newSections[action.sectionIndex];
      const arrayField = section[action.arrayField];
      const updatedArray = [...arrayField];

      if (action.nestedField) {
        updatedArray[action.itemIndex] = {
          ...updatedArray[action.itemIndex],
          [action.nestedField]: action.value,
        };
      } else {
        updatedArray[action.itemIndex] = action.value;
      }

      newSections[action.sectionIndex] = {
        ...section,
        [action.arrayField]: updatedArray,
      };

      return {
        ...state,
        sections: newSections,
      };
    }

    case PLACEMENT_ACTIONS.UPDATE_NESTED_ARRAY_ITEM: {
      // For deeply nested arrays like premiums[i].instalments[j]
      const newSections = [...state.sections];
      const section = newSections[action.sectionIndex];
      const parentArray = [...section[action.parentArrayField]];
      const parentItem = parentArray[action.parentItemIndex];
      const childArray = [...parentItem[action.childArrayField]];

      childArray[action.childItemIndex] = {
        ...childArray[action.childItemIndex],
        [action.field]: action.value,
      };

      parentArray[action.parentItemIndex] = {
        ...parentItem,
        [action.childArrayField]: childArray,
      };

      newSections[action.sectionIndex] = {
        ...section,
        [action.parentArrayField]: parentArray,
      };

      return {
        ...state,
        sections: newSections,
      };
    }

    case PLACEMENT_ACTIONS.ADD_SECTION_ARRAY_ITEM: {
      const newSections = [...state.sections];
      const section = newSections[action.sectionIndex];
      const arrayField = section[action.arrayField] || [];

      newSections[action.sectionIndex] = {
        ...section,
        [action.arrayField]: [...arrayField, action.newItem],
      };

      return {
        ...state,
        sections: newSections,
      };
    }

    case PLACEMENT_ACTIONS.REMOVE_SECTION_ARRAY_ITEM: {
      const newSections = [...state.sections];
      const section = newSections[action.sectionIndex];
      const arrayField = [...section[action.arrayField]];

      arrayField.splice(action.itemIndex, 1);

      newSections[action.sectionIndex] = {
        ...section,
        [action.arrayField]: arrayField,
      };

      return {
        ...state,
        sections: newSections,
      };
    }

    default:
      return state;
  }
}

// Hook
export function usePlacementReducer(initialState) {
  return useReducer(placementReducer, initialState);
}
